module.exports = __webpack_public_path__ + "static/media/group_photo_3.e9e81ca2.jpg";